<template>
    <el-drawer size="520px"
               class="custom_drawer"
               :withHeader="false"
               :visible.sync="commonApprovalVisible"
               :close-on-press-escape="false"
               :wrapperClosable="false"
               :before-close="handleClickClose">
        <div class="drawer_wrap">
            <div class="drawer_header">
                <h3 class="title">添加常用</h3>
                <span class="handle_icon_wrap" @click="handleClickClose">
                     <i class="el-icon-close" ></i>
                </span>
            </div>
            <div class="drawer_body" v-loading="loading">
                <div class="common_approval_drawer">
                    <div class="common_approval_drawer_top">
                        <div class="common_approval_drawer_title">已添加审批</div>
                        <div class="common_approval_drawer_top_list">
                            <ul>
                                <draggable v-model="common_approval_list"  ghostClass="common_ghost_class" chosenClass="common_chosen_class" filter=".no_common">
                                    <li v-for="(item,key) in common_approval_list" :key="key">
                                        <i @click="handleClickDel(item,key)"  class="iconfont icon-jianqu"></i>
                                        <div class="icon">
                                            <img :src="item.icon" alt="">
                                        </div>
                                        <p class="ellipsis_2" v-text="item.name"></p>
                                    </li>
                                    <li class="no_common" v-if="common_approval_list.length < 8" v-for="item in (8 - common_approval_list.length)">
                                        下方添加审批
                                    </li>
                                </draggable>
                            </ul>
                        </div>
                    </div>

                    <div class="common_approval_drawer_bottom">
                        <div class="common_approval_drawer_title">全部审批</div>
                        <div class="common_approval_drawer_bottom_search">
                            <el-input  v-model="searchForm.keyword" size="small"  placeholder="搜索您想要的内容"   suffix-icon="el-icon-search"  clearable  @clear="handleClickSearch"  @keyup.enter.native="handleClickSearch"></el-input>
                        </div>
                        <div class="common_approval_drawer_bottom_tab" v-if="all_approval_list && all_approval_list.length">
                            <el-tabs v-model="activeName" @tab-click="handleClickTab" >
                                <el-tab-pane  v-for="item in all_approval_list" :label="item.name" :name="String(item.id)" >
                                    <div class="common_approval_drawer_bottom_list">
                                        <ul>
                                            <li v-for="list in item.approvals">

                                                <div class="left">
                                                    <img :src="list.icon" alt="">
                                                    <span class="ellipsis" v-text="list.name"></span>
                                                </div>
                                                <div class="right_btn">
                                                    <el-button :disabled="list.status" class="custom_plain_btn" @click="handleClickAdd(list)" size="mini" plain>添加</el-button>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </el-tab-pane>
                            </el-tabs>
                        </div>

                    </div>
                </div>
            </div>
            <div class="drawer_footer">
                <el-button size="small" @click="handleClickClose">取消</el-button>
                <el-button :disabled="btnDisabled" size="small" type="primary" @click="handleClickConfirm">确定
                </el-button>
            </div>
        </div>
    </el-drawer>
</template>
<script>
import draggable from "vuedraggable";
import { approvalList,createCommon,commonList } from "@/api/index.js"
export default {
    name: 'commonApproval',
    components: { draggable },
    props: {
        commonApprovalVisible: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            loading: false,
            btnDisabled: false,
            searchForm:{
              keyword:''
            },
            activeName:null,
            common_approval_list:[ ],
            all_approval_list:[],

        }
    },
    computed: {

    },
    mounted() {

    },
    created() {
        this.getCommonApprovalData()
    },
    methods: {
        // 获取常用审批
        getCommonApprovalData(){
            this.loading = true
            commonList().then(res=> {
                if(res.code === 200) {
                    this.common_approval_list = res.data.map((item)=>{
                        return {
                            ...item.approval_set,
                        }
                    })
                }
                this.getApprovalData()
            })

        },
        // 获取所有审批
        getApprovalData(){
            this.loading = true
            approvalList({keyword:this.searchForm.keyword}).then(res=> {
                if(res.code === 200) {
                    res.data.forEach((item)=>{
                        if(item.approvals && item.approvals.length>0){
                            item.approvals.forEach((child)=>{
                                if(this.common_approval_list.find(find => find.id == child.id)){
                                    this.$set(child,'status',true)
                                }
                            })
                        }

                    })
                    this.all_approval_list = res.data
                    if(res.data && res.data.length>0){
                        this.activeName = String(res.data[0].id)
                    }
                }
                this.loading = false
            })
        },
        // 搜索
        handleClickSearch(){
            this.getApprovalData()
        },
        handleClickTab(val){

        },
        handleClickAdd(list){
            if(this.common_approval_list.length == 8){ return this.$message.error('最多添加8个常用审批，如需添加请先移除后再操作') }
            this.$set(list,'status',true)
            this.common_approval_list.push(list)
        },
        handleClickDel(item,key){
            this.common_approval_list.splice(key,1)
            this.all_approval_list.forEach((item)=>{
                if(item.approvals && item.approvals.length>0){
                    item.approvals.forEach((child)=>{
                        this.$set(child,'status',false)
                        if(this.common_approval_list.find(find => find.id == child.id)){
                            this.$set(child,'status',true)
                        }
                    })
                }
            })
        },
        //取消事件
        handleClickClose() {
            this.$emit('update:commonApprovalVisible', false)
        },

        //确定事件
        handleClickConfirm() {
            let common_data = this.common_approval_list.map(item => {
                return item.id
            })
            this.btnDisabled = true
            createCommon({common_data:common_data}).then(res=> {
                if(res.code === 200) {
                    this.$message({
                        showClose: true,
                        message: '添加成功',
                        type: 'success',
                        duration: 2000,
                        onClose: () => {
                            this.handleClickClose()
                            //父页面刷新列表
                            this.$emit('success')
                        }
                    });
                }else{
                    this.btnDisabled = false
                }
            })
        },
    },
}
</script>
<style lang="scss" scoped>
    .common_approval_drawer{
        width: 100%;
        .common_approval_drawer_title{
            width: 100%;
            line-height: 22px;
            margin-bottom: 4px;
            font-weight: bold;
            color: rgba(51, 51, 51, 1);
            font-size: 14px;
        }
        .common_approval_drawer_top{
            width: 100%;
            border-radius: 6px;
            background: rgba(255, 255, 255, 1);
            margin-bottom: 8px;
            padding: 16px;
            box-sizing: border-box;
            .common_approval_drawer_top_list{
                width: 100%;
                ul{
                    width: 100%;

                    &>div{
                        width: 100%;
                        display: flex;
                        flex-wrap: wrap;
                    }
                    li{
                        min-width: 110px;
                        flex: 0 1 calc(25% - 6px);
                        border-radius: 4px;
                        background: rgba(255, 255, 255, 1);
                        border: 1px solid rgba(0, 0, 0, 0.04);
                        padding:0 8px;
                        height: 44px;
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        cursor: pointer;
                        margin-top: 8px;
                        margin-right: 8px;
                        position: relative;
                        i{
                            position: absolute;
                            right: -6px;
                            top: -6px;
                            font-size: 12px;
                            cursor: pointer;
                            color: rgba(228, 65, 68, 1);
                            display: none;
                        }
                        &:hover i{
                            display: block;
                        }
                        &:nth-of-type(4n){
                            margin-right: 0;
                        }
                        &.common_ghost_class{
                            background: rgba(255, 255, 255, 0.6);
                            box-shadow: 0px 2px 4px 2px rgba(0, 0, 0, 0.08);
                        }
                        &.no_common{
                            border-radius: 4px;
                            background: rgba(247, 248, 250, 1);
                            border: 1px dashed rgba(232, 232, 232, 1);
                            justify-content: center;
                            line-height: 58px;
                            color: rgba(153, 153, 153, 1);
                            font-size: 12px;
                        }
                        &:hover{
                            background: rgba(0, 0, 0, 0.04);
                        }
                        .icon{
                            width: 16px;
                            img{
                                display: block;
                                width: 16px;
                                height: 16px;
                                border-radius: 4px;
                            }
                        }
                        p{
                            width: calc(100% - 16px);
                            padding-left: 4px;
                            box-sizing: border-box;
                            color: rgba(102, 102, 102, 1);
                            font-size: 12px;
                            line-height: 18px;
                            max-height: 36px;
                        }
                    }
                }
            }
        }
        .common_approval_drawer_bottom{
            border-radius: 6px;
            background: rgba(255, 255, 255, 1);
            padding: 16px;
            box-sizing: border-box;
            .common_approval_drawer_bottom_search{
                width: 100%;
                padding: 8px 0;
            }
            .common_approval_drawer_bottom_tab{
                width: 100%;
                position: relative;
                &:after{
                    content: ' ';
                    background: rgba(232, 232, 232, 1);
                    position: absolute;
                    left:-16px;
                    right:-16px;
                    top:38px;
                    height: 1px;
                };
                ::v-deep .el-tabs__header{
                    margin-bottom: 0;
                }
                ::v-deep .el-tabs__nav-wrap::after{
                    display: none;
                }
                ::v-deep .el-tabs__active-bar{
                    display: none;
                }
                ::v-deep .el-tabs__item{
                    padding: 0 12px !important;
                    color: rgba(102, 102, 102, 1);
                    font-size: 14px;
                    &.is-active{
                        color: rgba(41, 144, 255, 1);
                        font-weight: bold;
                        &:before{
                            height: 2px;
                            opacity: 1;
                            background: rgba(41, 144, 255, 1);
                            content: ' ';
                            left: 0;
                            bottom: 1px;
                            position: absolute;
                            width: 100%;
                        }
                    }
                }

                .common_approval_drawer_bottom_list{
                    width: 100%;
                    ul{
                        width: 100%;
                        li{
                            margin-top: 16px;
                            display: flex;
                            justify-content: space-between;

                            .left{
                                width: calc(100% - 80px);
                                display: flex;
                                line-height: 24px;
                                align-items: center;
                                img{
                                    width: 24px;
                                    height: 24px;
                                    display: block;
                                    border-radius: 8px;
                                }
                                span{
                                    font-size: 14px;
                                    color: rgba(102, 102, 102, 1);
                                    line-height: 24px;
                                    padding:0 8px;
                                    max-width: calc(100% - 24px);
                                }
                            }
                            .right_btn{
                                width: 80px;
                                text-align: right;
                            }
                        }
                    }
                    .custom_plain_btn{
                        padding: 6px 15px;
                        border-radius: 4px;
                        border: 1px solid rgba(41, 144, 255, 1);
                        color: rgba(41, 144, 255, 1);
                        &.is-disabled{
                            background: rgba(247, 247, 247, 1);
                            border: 1px solid rgba(217, 217, 217, 1);
                            color: rgba(191, 191, 191, 1);
                        }
                    }
                }

            }
        }
    }
</style>
